import { Link } from "react-router-dom"
import { Card, Col, Image, Row } from "react-bootstrap"
import { BsCalendar, BsClockFill } from "react-icons/bs"
import { FaRegClock, FaPen, FaRegEye } from "react-icons/fa"
import { BiDollarCircle } from "react-icons/bi"
import { IoCloseCircle } from "react-icons/io5"
import { withTranslation } from "react-i18next"
import moment from 'moment'
import userDefault from '../img/userdefault.png'
import { AiOutlineFileDone } from "react-icons/ai"
import { HiOutlineTrash } from "react-icons/hi"
import EnviarDocumentos from "./citas/EnviarDocumentos"
import DescargarDocumentos from "./citas/DescargarDocumentos"

function CardCitasCliente({ t, item, showModal, showDelete = true, showEdit = true, auth, currentDoctorId, companyType}) {
    const { patientDTO, scheduleDTO } = item
    
    // For Colombia: check if current doctor matches appointment doctor
    // Convert both to numbers for comparison to handle string/number mismatch
    const isCurrentDoctor = companyType === "colombia" && currentDoctorId 
        ? Number(currentDoctorId) === Number(scheduleDTO?.doctor?.id)
        : true // For Mexico, always show buttons (default behavior)


    return(
        <Card className="shadow-1 mb-2">
            <Card.Body className="p-0">
                <div className="px-3 pt-3">
                    <div className="position-relative">
                        {
                            item.appointmentStatus!=="Cancelada" && 
                            <ul className="list-unstyled card-actions">
                                <li><Link to={`${item.externalUrl ? `/admin/proveedor/citacliente/${btoa(item.id)}` : `/admin/proveedor/conferencia/${btoa(item.id)}`}`}><FaRegEye className="text-secondary"/></Link></li>
                                <li><AiOutlineFileDone className="color-C1C1C1"/></li>
                                {showDelete && <li><HiOutlineTrash className="color-red" onClick={e=>showModal(item)}/></li>}
                            </ul>
                        }
                    </div>
                    <Row>
                        <Col className="d-none d-md-block text-center" md="4">
                            <Image src={ userDefault } fluid className="img-card-citas"/><br/>
                            { (showEdit && item.appointmentStatus !== 'Cancelada') && <Link to={`/admin/proveedor/editar-cita/${item?.id}/${scheduleDTO?.doctor?.id}/${patientDTO?.id}`}>
                                    <FaPen className='colorNaranja clicked' />
                                </Link> 
                            }
                        </Col>
                        <Col xs="12" md="8">
                            <div className="name-doctor">
                                <label className="d-block text-blue-2 text-center font-weight-bold mb-2 lh-1">{`${patientDTO?.name ? `${patientDTO?.name} ${patientDTO.middleName ?? ''} ${patientDTO?.lastName ?? ''} ${patientDTO.seccondSurname ?? ''}`: `${patientDTO.email}`}`}</label>
                                <div className="text-secondary font-weight-bold-600 font-size-07rem">
                                    <div className='text-center'>
                                        <BsCalendar className="mb-1"/> {moment(scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMM YYYY")}
                                        &nbsp;&nbsp;
                                        <FaRegClock /> {moment(scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("HH:mm")}
                                    </div>
                                </div>
                                {/* For Colombia: show doctor name if different doctor, otherwise show document buttons */}
                                {companyType === "colombia" && !isCurrentDoctor && scheduleDTO?.doctor && (
                                    <div className="text-center text-secondary font-weight-bold-600 font-size-07rem mb-2">
                                        {t('doctor')}: {scheduleDTO.doctor.name} {scheduleDTO.doctor.lastName}
                                    </div>
                                )}
                                {isCurrentDoctor && (
                                    <div className="d-flex">
                                        {item.appointmentStatus!=='Fallida' && <div className="pr-2"><EnviarDocumentos id={item.id} auth={auth}/></div>}
                                        <div className={item.appointmentStatus==='Fallida' ? 'm-auto' : ''}>
                                            <DescargarDocumentos 
                                                id={item.id} 
                                                auth={auth} 
                                                appoinmentStatus={item.appointmentStatus}/>
                                            </div>                                
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>                            
                <hr className="mt-2 mb-0"/>
                {
                        item.appointmentStatus==='Fallida' ? 
                        <div className="d-flex justify-content-center p-2">
                            <div><span className={`font-size-08rem font-weight-bold-600 text-fallida`}><IoCloseCircle className="mb-03rem"/> Fallida</span></div>
                        </div> :
                        <div className="d-flex flex-md-row flex-column justify-content-center justify-content-md-between p-2 align-items-center">
                            <div><span className={`font-size-08rem font-weight-bold-600 ${item.appointmentStatus==='Pendiente' ? 'color-yellow' : 'color-C1C1C1'}`}><BsClockFill className="mb-03rem"/>{ t('pendiente') }</span></div>
                            <div><span className={`font-size-08rem font-weight-bold-600 ${item.appointmentStatus==='Pagada' ? 'color-green' : 'color-C1C1C1'}`}><BiDollarCircle className="mb-03rem"/>{ t('pagada') }</span></div>
                            <div><span className={`font-size-08rem font-weight-bold-600 ${item.appointmentStatus==='Cancelada' ? 'color-red' : 'color-C1C1C1'}`}><IoCloseCircle className="mb-03rem"/>{ t('cancelada') }</span></div>
                        </div>
                }
                
            </Card.Body>
        </Card>
    )
}

export default withTranslation()(CardCitasCliente)